import React, { useEffect, useState } from "react"
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getTicketDetails } from "store/actions/customerSupportAction"
import formatDateTime from "components/Shared/formatDateTime"
import TableShimmer from "components/Shared/TableShimmer"
import { ticketListsStatus } from "components/Common/constants"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap"

const TicketDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Ticket Details | Namq`)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalImage, setModalImage] = useState(null)

  const { userRole, accountType } = useSelector(state => state.Login)

  const toggleModal = () => setIsModalOpen(!isModalOpen)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      17,
      "customer_support_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  const { loading, ticketDetails } = useSelector(state => state.CustomerSupport)

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getTicketDetails(payload))
    }
    fetchOldDetails()
  }, [])

  const renderTicketStatus = actionType => {
    return t(ticketListsStatus[actionType]) || ""
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={8}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Ticket Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(ticketDetails).length === 0 ? (
                    <p className="text-center">
                      {t("No ticket details found")}
                    </p>
                  ) : (
                    <Table className="mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{ticketDetails?._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(English)")}</th>
                          <td>{ticketDetails?.issueType?.title || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(عربي)")}</th>
                          <td>{ticketDetails?.issueType?.titleAr || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Full Name")}</th>
                          <td>{ticketDetails?.fullName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Email")}</th>
                          <td>{ticketDetails?.email || "-"}</td>
                        </tr>
                        {/* <tr>
                          <th scope="row">Phone Code</th>
                          <td>{ticketDetails?.phoneCode || "-"}</td>
                        </tr> */}
                        <tr>
                          <th scope="row">{t("Phone Number")}</th>
                          <td>{ticketDetails?.phoneNumber || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Body")}</th>
                          <td>{ticketDetails?.body || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {renderTicketStatus(ticketDetails?.status) || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Attachments")}</th>
                          <td>
                            {ticketDetails?.attachments && (
                              <img
                                src={ticketDetails?.attachments}
                                alt=""
                                className="img-fluid cursor-pointer"
                                style={{ objectFit: "contain", maxHeight: 200 }}
                                onClick={toggleModal}
                              />
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Created At")}</th>
                          <td>{formatDateTime(ticketDetails?.createdAt)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Updated At")}</th>
                          <td>{formatDateTime(ticketDetails?.updatedAt)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="full_height_card">
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  {t("Customer Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(ticketDetails).length === 0 ? (
                    <p className="text-center">
                      {t("No customer details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Customer Id")}</th>
                          <td>{ticketDetails?.userId?._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("First Name")}</th>
                          <td>{ticketDetails?.userId?.firstName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Last Name")}</th>
                          <td>{ticketDetails?.userId?.lastName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name")}</th>
                          <td>{ticketDetails?.userId?.name || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Email")}</th>
                          <td>{ticketDetails?.userId?.email || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Phone Number")}</th>
                          <td>{ticketDetails?.userId?.phoneNumber || "-"}</td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle>{t("Status History")}</CardTitle>
                <div
                  className="table-responsive"
                  style={{ maxHeight: 600, overflow: "auto" }}
                >
                  {loading ? (
                    <TableShimmer row={7} col={5} />
                  ) : ticketDetails?.statusHistory?.length === 0 ? (
                    <p className="text-center my-2">
                      {t("No status history found")}
                    </p>
                  ) : (
                    <Table className="table mb-0" hover>
                      <thead className="table-light">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Status")}</th>
                          <th>{t("Remark")}</th>
                          <th>{t("Date")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketDetails?.statusHistory?.map(
                          ({ _id, status, description, date }, index) => (
                            <tr
                              key={index}
                              //   onClick={() =>
                              //     navigate(
                              //       `/support-tickets/ticket-details?id=${_id}`
                              //     )
                              //   }
                              //   className="cursor-pointer"
                            >
                              <th scope="row">{index + 1}</th>
                              <td>{renderTicketStatus(status)}</td>
                              <td>{description || "-"}</td>
                              <td>{formatDateTime(date) || "-"}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle>{t("Previous Tickets")}</CardTitle>
                <div
                  className="table-responsive"
                  style={{ maxHeight: 600, overflow: "auto" }}
                >
                  {loading ? (
                    <TableShimmer row={7} col={5} />
                  ) : ticketDetails?.previousTickets?.length === 0 ? (
                    <p className="text-center my-2">
                      {t("No previous tickets found")}
                    </p>
                  ) : (
                    <Table className="table mb-0" hover>
                      <thead className="table-light">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Name")}</th>
                          <th>{t("Email")}</th>
                          <th>{t("Phone Number")}</th>
                          <th>{t("Issue Title")}</th>
                          <th>{t("Body")}</th>
                          <th>{t("Issue Type")}</th>
                          <th>{t("Status")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketDetails?.previousTickets?.map(
                          (
                            {
                              _id,
                              fullName,
                              email,
                              phoneNumber,
                              body,
                              status,
                              ticketId,
                              issueType,
                            },
                            index
                          ) => (
                            <tr
                              key={index}
                              //   onClick={() =>
                              //     navigate(
                              //       `/support-tickets/ticket-details?id=${_id}`
                              //     )
                              //   }
                              //   className="cursor-pointer"
                            >
                              <th scope="row">{index + 1}</th>
                              <td>{fullName || "-"}</td>
                              <td>{email || "-"}</td>
                              <td>{phoneNumber || "-"}</td>
                              <td>
                                {language === "sa"
                                  ? issueType?.titleAr
                                  : issueType?.title || "-"}
                              </td>
                              <td>{body}</td>
                              <td>{ticketId}</td>
                              <td>{renderTicketStatus(status)}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        className="ticket_attachment_modal"
        centered
        size="lg"
      >
        <ModalHeader toggle={toggleModal}>{t("Attachments")}</ModalHeader>
        <ModalBody className="text-center">
          {ticketDetails?.attachments && (
            <img
              src={ticketDetails?.attachments}
              alt="Attachment"
              className="img-fluid"
              style={{
                objectFit: "contain",
                maxWidth: "100%",
                maxHeight: "70vh",
              }}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default TicketDetails
